module.exports = __webpack_public_path__ + "img/visa.cb0e7fd0.svg";